import React from 'react';
import { Button, Row, Col } from 'antd';
import {
  FileAddOutlined, ToolOutlined, FileTextOutlined, SettingOutlined, RiseOutlined, TeamOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const ACTIONS: Array<{ label: string; icon: React.ReactNode; route: string; primary?: boolean }> = [
  { label: 'New Estimate', icon: <FileAddOutlined />, route: '/owner/estimates/new', primary: true },
  { label: 'New Work Order', icon: <ToolOutlined />, route: '/owner/work-orders/new', primary: true },
  { label: 'Open Estimates', icon: <FileTextOutlined />, route: '/owner/estimates' },
  { label: 'Work Orders', icon: <SettingOutlined />, route: '/owner/work-orders' },
  { label: 'Reports', icon: <RiseOutlined />, route: '/owner/reports' },
  { label: 'Manage Users', icon: <TeamOutlined />, route: '/owner/users' },
];

const QuickStartActions: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Row gutter={[8, 8]}>
      {ACTIONS.map((a) => (
        <Col xs={12} md={8} lg={4} key={a.label}>
          <Button
            block
            size="large"
            type={a.primary ? 'primary' : 'default'}
            icon={a.icon}
            style={{ height: 48 }}
            onClick={() => navigate(a.route)}
          >
            {a.label}
          </Button>
        </Col>
      ))}
    </Row>
  );
};

export default QuickStartActions;
